import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { createPlayers, createScorers } from 'src/app/store/actions/account.action';
import { createLeaguePlayers } from 'src/app/store/actions/tournament.action';
import { AppState } from 'src/app/store/app.state';
@Component({
  selector: 'app-review-details',
  templateUrl: './review-details.component.html',
  styleUrls: ['./review-details.component.scss']
})
export class ReviewDetailsComponent implements OnInit {
  payload!: any;
  payloadKeys: any;
  type!: any;

  league!: any

  constructor(
    private modalService: ModalService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    console.log(this.league);
    this.payloadKeys = Object.keys(this.payload).filter((key: string) => key !== "password" && key !== "password_confirmation" && key !== "leagueId");
  }

  close() {
    this.modalService.hideReviewDetails(); 
  }

  confirmSubmit() {
    switch(this.type){
      case 'create-player':
        return this.store.dispatch(createPlayers({data: this.payload}));
      case 'create-scorer':
        return this.store.dispatch(createScorers({data: this.payload}));
      case 'create-league-player':
        return this.store.dispatch(createLeaguePlayers({data: this.payload, league: this.league}));
    }
  }
}
